

















import _ from "lodash";
import { Component, Vue } from "vue-property-decorator";
import EmailHistory from "@/components/viewemailmaintenancejobhistory/EmailHistory.vue";

@Component({
  components: {
    EmailHistory
  }
})
export default class EmailReportHistory extends Vue {
  public showEmailHistoryModal() {
    const modal = (this.$refs.mergeReportModal as any).$el;
    ($(modal) as any).modal("show");
  }
}
